import type { ListData } from '@bluevision/tools';
import i18n from '@/i18n';

import { post, read } from '@/utils/request';
import type { GoogleAppAPI } from '@/services/opentingAccount/typings';
import type { GoogleAccountAPI } from '@/services/accounts/typings';

const api = 'application/google/list';

const getList = (params: GoogleAccountAPI.SearchParams) => {
  return read<ListData<GoogleAppAPI.Info>>(api, params);
};

const getDetail = (id: string) => {
  return read<GoogleAccountAPI.Detail>(api, undefined, 'accounts.google.detail', id);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const searchBalance = (params?: any) => {
  return post(
    'user_account/account_balance',
    {
      ...params,
      type: 1,
    },
    i18n.t('account_balance_query_failed'),
  );
};

const getMccBelongGrayscale = () => {
  return read<GoogleAccountAPI.MccBelong>(
    'application/mcc_belong_grayscale',
    undefined,
    undefined,
    undefined,
    undefined,
    {
      baseAPI: '/api/v1',
    },
  );
};

export { getList, getDetail, searchBalance, getMccBelongGrayscale };
